import {
  faChartLine,
  faFileImage,
  faListAlt,
  faTachometer,
  faTasks,
  faTasksAlt,
  faUsers,
} from '@fortawesome/pro-light-svg-icons'

const generateMainNavigationItems = (params) => {
  const { isTeamLead, teamsWhereTeamLeadIds } = params

  return {
    sections: [
      {
        key: 'dashboard',
        visible: true,
        items: [
          {
            href: '#/',
            icon: faTachometer,
            key: 'dashboard',
            title: 'Overview',
            visible: true,
          },
        ],
      },
      {
        key: 'projects',
        title: 'Projects',
        visible: true,
        items: [
          {
            href: '#/analytics',
            icon: faChartLine,
            key: 'analytics',
            title: 'Analytics',
            visible: true,
          },
          {
            href: `#/tasks/teamOverview?team_id=${teamsWhereTeamLeadIds[0]}`,
            icon: faUsers,
            key: 'team',
            title: 'Team',
            visible: isTeamLead,
          },
          {
            href: '#/projects?adHoc=false',
            icon: faTasksAlt,
            key: 'projects',
            title: 'Projects',
            visible: true,
          },
          {
            href: '#/tasks?sub_tasks=false',
            icon: faTasks,
            key: 'tasks',
            title: 'Tasks',
            visible: true,
          },
          {
            href: '#/tasks?sub_tasks=true',
            icon: faTasks,
            key: 'subTasks',
            title: 'Sub Tasks',
            visible: true,
          },
          {
            href: '#/qualityControl/taskListTemplates',
            icon: faListAlt,
            key: 'checklists',
            title: 'Checklists',
            visible: true,
          },
        ],
      },
      {
        key: 'templates',
        title: 'Templates',
        visible: true,
        items: [
          {
            href: '#/templatePages?hidden=false',
            icon: faFileImage,
            key: 'templatePages',
            title: 'Templates',
            visible: true,
          },
          {
            href: '#/templatePagePartials?hidden=false',
            icon: faFileImage,
            key: 'templatePagePartials',
            title: 'Icons & Partials',
            visible: true,
          },
          {
            href: '#/layoutTemplates?hidden=false',
            icon: faFileImage,
            key: 'layoutTemplates',
            title: 'Layouts',
            visible: true,
          },
        ],
      },
    ],
  }
}

export default generateMainNavigationItems
